const HOMOGLYPH_MAP = {
    а: 'a', в: 'b', е: 'e', ё: 'e', к: 'k', м: 'm', н: 'n',
    о: 'o', р: 'p', с: 'c', т: 't', у: 'y', х: 'x'
};

export const normalizeHomoglyphs = (text) => {
    if (!text) return '';
    // Приводим к нижнему регистру и заменяем похожие кириллические символы на латинские
    return text.toLowerCase().replace(/[аавеёкмнопрстуух]/g, char => HOMOGLYPH_MAP[char]);
};